import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    '& p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  menuIcon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(1),
  },
  plainBackground: {
    background: theme.palette.background.paper,
    '&:focus': {
      background: theme.palette.background.paper,
    },
  },
  check: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 24,
    height: 24,
    padding: 2,
  },
  ignore: {
    backgroundColor: theme.palette.error.light,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 24,
    height: 24,
    padding: 2,
  },
  link: {
    backgroundColor: theme.palette.text.secondary,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 24,
    height: 24,
    padding: 2,
  },

  smallCheck: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
  smallX: {
    backgroundColor: theme.palette.error.light,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
  smallLink: {
    backgroundColor: theme.palette.text.secondary,
    borderRadius: '50%',
    color: theme.palette.background.paper,
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
}));
